import Magnetic from 'Scripts/components/Magnetic'
import Dropdown from 'Scripts/components/Dropdown'
import Button from 'Scripts/components/Button'
import Theme from 'Scripts/components/Theme'
import Animation from 'Scripts/components/Animation'
// import Modal from 'Scripts/components/Modal'
// import Filter from 'Scripts/components/Filter'
// import Pagination from 'Scripts/components/Pagination'

export default class Page {
  constructor(page, { container, elements }) {
    this.page = page
    this.container = container
    this.elements = {}
    this.selectors = {
      ...elements
    }

    //Methods
    this.create()

  }

  create() {
    this.pageNode = this.container instanceof HTMLElement ? this.container : document.querySelector(this.container)

    for (const [key, selector] of Object.entries(this.selectors)) {
      if (selector instanceof HTMLElement || selector instanceof NodeList) {
        this.elements[key] = selector
      } else {
        this.elements[key] = document.querySelectorAll(selector)
        if (this.elements[key].length === 1) {
          this.elements[key] = document.querySelector(selector)
        } else if (this.elements[key].length === 0) {
          this.elements[key] = null
        }
      }
    }

    //Init Components
    this.createComponents()
    // this.addEventListeners()

  }

  createComponents() {
    //Magnetic
    new Magnetic({ selector: '.magnetic' })
    //DropDown
    new Dropdown({ selector: '.dropdown' })
    //Button
    new Button({ selector: '.btn' })
    //Theme : Dark/Light
    new Theme({ selector: '[data-theme-update]' })
    //Modal
    // this.initModal()
    //Filters
    // new Filter()
    //Pagination    
    // this.initPagination()

  }

  // initModal() {
  //   new Modal({ selector: '[data-modal]' })
  // }

  // initPagination() {
  //   this.elements.paginationLink && new Pagination(this.elements.paginationLink, this.elements.moduleWrapper).change(1)
  // }

  show() {
    // this.reset()
    this.isVisible = true
    // 
    // this.textAnimation = new Animation({ selector: '[data-animation]' })
    // this.imageAnimation = new Animation({ selector: '[data-scroll]' })
    // console.log('show : ' + this.page)
  }

  hide() {
    this.isVisible = false
    // console.log('hide')
  }

  onResize() {
   
  }

  onMouseWheel(event) {
    const { deltaY } = event
  }
  /**
  * Listeners.
  */
  addEventListeners() {
    window.addEventListener('mousewheel', this.onMouseWheel.bind(this))
    window.addEventListener('wheel', this.onMouseWheel.bind(this))
  }

  removeEventListeners() {
    window.removeEventListener('mousewheel', this.onMouseWheel.bind(this))
    window.removeEventListener('wheel', this.onMouseWheel.bind(this))
  }

  update() {
   
  }

}